import { FC, useEffect, useState } from "react";
import { Table } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { useMaintenanceDetailsModel } from "../MaintenanceModel";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IItemDetailList } from "../MaintenanceType";

// 商品属性
const ItemAttr = new Map([
    ["import", "进口"],
    ["domestic", "国产"],
]);
export const ItemTableBox: FC<RouterParamType> = () => {

    const { getSelectedNavState } = useNavModel(({ selectedNavId }) => [selectedNavId])
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType)
    const { orderInfo } = detailsInfo

    const { itemDetail } = useMaintenanceDetailsModel();
    const [totalPrice, setTotalPrice] = useState<string>("0");
    const [columns, setColumns] = useState<any[]>([])

    const title = <>
        <span style={{ fontSize: 20, fontWeight: 'bold', marginLeft: -15 }}>维修项目</span>
        <span style={{ marginLeft: 50, fontSize: 14 }}>
            总金额&nbsp;¥&nbsp;<span style={{ color: 'red', fontSize: 18 }}>{totalPrice}</span>
            &nbsp;元&nbsp;({itemDetail.length}项){" "}
        </span>
    </>

    useEffect(() => {
        let num: number = 0;
        let colms: any[] = [];
        itemDetail.forEach((item) => {
            num += Number(item.actualAmount);

            const info = orderInfo.itemsList.filter((e: any) => e.id === item.id)?.[0];
            if (info != null) {
                info?.fields?.forEach((e: any) => {
                    item[e.fieldCode] = e.fieldValue
                })

                colms = info?.fields?.map((e: any) => {
                    return {
                        title: e.fieldName,
                        width: e.fieldName.length * 16,
                        align: 'center',
                        dataIndex: e.fieldCode
                    }
                });
            }
        })
        setTotalPrice(num.toFixed(2));
        getColumns(colms);
    }, [itemDetail])

    const getColumns = (customerColumns: any[]) => {
        setColumns([...startColumns, ...customerColumns, ...endColumns])
    }

    const startColumns: ColumnsType<IItemDetailList> = [
        {
            title: '序号',
            width: 50,
            align: "center",
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            title: "项目编码",
            align: "center",
            width: 120,
            dataIndex: "itemCode",
        },
        {
            title: "项目名称",
            align: "center",
            width: 300,
            dataIndex: "itemName",
            render: (text, record) =>
                record.state === "refuse_repair" ? (
                    <span>
                        {text}
                        <span style={{ color: "#f00" }}>(拒修)</span>
                    </span>
                ) : (
                    <>{text}</>
                ),
        },
        {
            title: "预付款",
            align: "center",
            width: 80,
            dataIndex: "prepayFlag",
            render: (text) => (text == 0 ? "否" : "是"),
        },
        {
            title: "项目属性",
            align: "center",
            width: 120,
            dataIndex: "itemAttr",
            render: (text) => <p>{ItemAttr.get(text)}</p>,
        },
        {
            title: "工时",
            align: "center",
            width: 80,
            dataIndex: "itemWorkHours",
        },
        {
            title: "单价",
            align: "center",
            width: 80,
            dataIndex: "workHoursPrice",
        },
        {
            title: "工时费",
            align: "center",
            width: 80,
            dataIndex: "itemAmount",
        },
        {
            title: "优惠",
            align: "center",
            width: 80,
            dataIndex: "preferentialAmount",
        },
        {
            title: "折扣",
            align: "center",
            width: 80,
            dataIndex: "itemDiscount",
        },
        {
            title: "总金额",
            align: "center",
            width: 80,
            dataIndex: "actualAmount",
        }
    ];

    const endColumns: ColumnsType<IItemDetailList> = [
        {
            title: "备注",
            align: "center",
            width: 200,
            dataIndex: "remark",
        }
    ];
    return (
        <YhBox title={title} style={{ marginBottom: 10, padding: 20 }}>
            <Table
                rowKey={record => record.detailsId as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={columns}
                dataSource={itemDetail}
                pagination={false}
                scroll={{ x: 'max-content', y: 250 }}
            />
        </YhBox>
    )
}